(function () {
  /* Load V3 cart drawer styles when layout HTML still references cart-drawer.css */
  (function ensureCartDrawerV3Styles() {
    if (document.querySelector('[data-cart-v3-styles]')) return;
    const legacyLink = document.querySelector('link[href*="cart-drawer.css"]');
    if (!legacyLink) return;
    const v3Link = document.createElement('link');
    v3Link.rel = 'stylesheet';
    v3Link.setAttribute('data-cart-v3-styles', '');
    v3Link.href = legacyLink.href.replace('cart-drawer.css', 'cart-drawer-v3.css');
    document.head.appendChild(v3Link);
  })();

  const PackPricing = window.VanabrewPackPricing;
  if (!PackPricing) return;

  const drawerSelector = '[data-cart-drawer]';
  const countSelector = '[data-cart-count]';
  const addFormSelector = 'form[action*="/cart/add"]';
  const panelSelector = '.cdp-cart-drawer';
  const productPackVariantCache = new Map();

  const QUANTITY_DEBOUNCE_MS = 200;
  const CART_ORDER_ATTR = 'vb_cart_order';

  let lastFocusedElement = null;
  let focusTrapHandler = null;
  let rebalanceLock = Promise.resolve();
  let drawerConfig = null;
  // Pending plus/minus targets keyed by product id — flush once after rapid clicks.
  const pendingQuantityByProduct = new Map();

  function getDrawer() {
    return document.querySelector(drawerSelector);
  }

  function getPanel(drawer) {
    return drawer ? drawer.querySelector(panelSelector) : null;
  }

  function readDrawerConfig() {
    const node = document.querySelector('[data-cart-drawer-config]');
    if (!node) {
      return {
        initialItemCount: Number(getDrawer()?.getAttribute('data-cart-item-count')) || 0,
        moneyFormat: getDrawer()?.getAttribute('data-cart-money-format') || '{{amount}}',
        maxPacks: Number(getDrawer()?.getAttribute('data-cart-max-packs')) || 20,
        grindOptions: ['Whole bean'],
        emptyTitle: 'Your brew bar is empty.',
        emptyCopy: 'Time to restock with something farm fresh and roasted just for you.',
        emptyCtaLabel: 'EXPLORE OUR COFFEES',
        emptyCtaUrl: '/collections/all',
      };
    }
    try {
      return JSON.parse(node.textContent || '{}');
    } catch {
      return {
        initialItemCount: Number(getDrawer()?.getAttribute('data-cart-item-count')) || 0,
        moneyFormat: getDrawer()?.getAttribute('data-cart-money-format') || '{{amount}}',
        maxPacks: Number(getDrawer()?.getAttribute('data-cart-max-packs')) || 20,
        grindOptions: ['Whole bean'],
        emptyTitle: 'Your brew bar is empty.',
        emptyCopy: 'Time to restock with something farm fresh and roasted just for you.',
        emptyCtaLabel: 'EXPLORE OUR COFFEES',
        emptyCtaUrl: '/collections/all',
      };
    }
  }

  function getConfig() {
    if (!drawerConfig) drawerConfig = readDrawerConfig();
    return drawerConfig;
  }

  function setCartCounts(count) {
    document.querySelectorAll(countSelector).forEach((node) => {
      node.textContent = String(count);
      node.classList.toggle('is-hidden', count === 0);
    });
  }

  function totalPackCount(cart) {
    return (cart.items || []).reduce((sum, item) => {
      const packs = PackPricing.packsFromCartItem(item);
      if (!packs) return sum + (Number(item.quantity) || 1);
      return sum + PackPricing.expandBagGrinds(item, packs).length;
    }, 0);
  }

  function totalPackCountFromDom() {
    let total = 0;
    document.querySelectorAll('[data-cart-pack-row]').forEach((row) => {
      total += Number(row.getAttribute('data-cart-pack-count')) || 0;
    });
    document.querySelectorAll('[data-cart-line-key]').forEach((row) => {
      total += Number(row.getAttribute('data-cart-quantity')) || 0;
    });
    return total;
  }

  function syncMagicCheckout(root, totalPriceCents) {
    const scope = root || document;
    const magicReady = typeof window.openRzpCheckout === 'function';

    scope.querySelectorAll('[data-magic-checkout]').forEach((wrap) => {
      wrap.classList.toggle('is-magic-ready', magicReady);

      const host = wrap.querySelector('magic-checkout-btn');
      if (host && typeof host.setAttribute === 'function' && Number.isFinite(totalPriceCents)) {
        host.setAttribute('amount', String(totalPriceCents));
      }
    });
  }

  function watchMagicCheckout() {
    syncMagicCheckout(getDrawer());
    if (typeof window.openRzpCheckout === 'function') return;

    let attempts = 0;
    const maxAttempts = 40;
    const timer = window.setInterval(() => {
      attempts += 1;
      syncMagicCheckout(getDrawer());
      if (typeof window.openRzpCheckout === 'function' || attempts >= maxAttempts) {
        window.clearInterval(timer);
      }
    }, 250);
  }

  function getFocusableElements(panel) {
    return panel.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
    );
  }

  function enableFocusTrap(panel) {
    disableFocusTrap();

    focusTrapHandler = (event) => {
      if (event.key !== 'Tab') return;

      const focusable = getFocusableElements(panel);
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    panel.addEventListener('keydown', focusTrapHandler);
  }

  function disableFocusTrap() {
    const panel = getPanel(getDrawer());
    if (panel && focusTrapHandler) {
      panel.removeEventListener('keydown', focusTrapHandler);
    }
    focusTrapHandler = null;
  }

  function openDrawer() {
    const drawer = getDrawer();
    const panel = getPanel(drawer);
    if (!drawer || !panel) return;

    lastFocusedElement = document.activeElement;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-cart-drawer-open');

    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
    });

    panel.focus();
    enableFocusTrap(panel);
  }

  function closeDrawer() {
    const drawer = getDrawer();
    const panel = getPanel(drawer);
    if (!drawer || !panel) return;

    drawer.classList.remove('is-open');
    document.body.classList.remove('is-cart-drawer-open');
    disableFocusTrap();

    const finishClose = () => {
      drawer.hidden = true;
      drawer.setAttribute('aria-hidden', 'true');

      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
      lastFocusedElement = null;
    };

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) {
      finishClose();
      return;
    }

    const onTransitionEnd = (event) => {
      if (event.target !== panel || event.propertyName !== 'transform') return;
      panel.removeEventListener('transitionend', onTransitionEnd);
      finishClose();
    };

    panel.addEventListener('transitionend', onTransitionEnd);
    window.setTimeout(finishClose, 350);
  }

  async function fetchCart() {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Failed to fetch cart state');
    return response.json();
  }

  async function updateCartAttributes(attributes) {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ attributes }),
    });
    if (!response.ok) throw new Error('Cart attribute update failed');
    return response.json();
  }

  function cartEntryKey(item) {
    const packs = PackPricing.packsFromCartItem(item);
    return packs ? String(item.product_id) : `legacy-${item.key}`;
  }

  function viewEntryKey(entry) {
    if (entry.kind === 'legacy') return `legacy-${entry.item.key}`;
    return String(entry.productId);
  }

  function parseCartOrder(cart) {
    const raw = cart?.attributes?.[CART_ORDER_ATTR];
    if (!raw) return [];
    return String(raw)
      .split('|')
      .map((value) => value.trim())
      .filter(Boolean);
  }

  // Shopify cart.items is newest-first. Walk oldest-first so first-added stays on top.
  function productKeysOldestFirst(cart) {
    const keys = [];
    const seen = new Set();
    const items = cart.items || [];
    for (let i = items.length - 1; i >= 0; i -= 1) {
      const key = cartEntryKey(items[i]);
      if (seen.has(key)) continue;
      seen.add(key);
      keys.push(key);
    }
    return keys;
  }

  async function resolveStableCartOrder(cart) {
    const presentOldestFirst = productKeysOldestFirst(cart);
    const present = new Set(presentOldestFirst);
    const stored = parseCartOrder(cart);

    let resolved;
    if (!stored.length) {
      resolved = presentOldestFirst;
    } else {
      const kept = stored.filter((key) => present.has(key));
      const newcomers = presentOldestFirst.filter((key) => !kept.includes(key));
      resolved = kept.concat(newcomers);
    }

    if (resolved.join('|') !== stored.join('|')) {
      try {
        await updateCartAttributes({ [CART_ORDER_ATTR]: resolved.join('|') });
      } catch (error) {
        console.error(error);
      }
    }

    return resolved;
  }

  async function updateCartQuantities(updates) {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updates }),
    });
    if (!response.ok) throw new Error('Cart update failed');
    return response.json();
  }

  async function changeCartLine(lineKey, payload) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: lineKey, ...payload }),
    });
    if (!response.ok) throw new Error('Cart update failed');
    return response.json();
  }

  async function addCartItems(items) {
    if (!items.length) return null;
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items }),
    });
    if (!response.ok) throw new Error('Cart add failed');
    return response.json();
  }

  async function fetchPackVariants(handle) {
    if (!handle) return [];
    if (productPackVariantCache.has(handle)) return productPackVariantCache.get(handle);

    const response = await fetch(`/products/${handle}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Failed to fetch product variants');
    const product = await response.json();
    const variants = (product.variants || [])
      .map((variant) => ({
        id: Number(variant.id),
        packs: PackPricing.packsFromProductVariant(variant),
        price: Number(variant.price),
        available: variant.available !== false,
      }))
      .filter((variant) => variant.packs > 0);

    productPackVariantCache.set(handle, variants);
    return variants;
  }

  function productLines(cart, productId) {
    return (cart.items || []).filter((item) => item.product_id === productId);
  }

  function expandProductBags(lines) {
    const bags = [];
    lines.forEach((line) => {
      const packs = PackPricing.packsFromCartItem(line);
      if (!packs) return;
      bags.push(...PackPricing.expandBagGrinds(line, packs));
    });
    return bags;
  }

  async function writeProductBags(productId, handle, bags) {
    const cart = await fetchCart();
    const lines = productLines(cart, productId);

    // Remove old lines in one request and warm variants in parallel.
    const removePromise = lines.length
      ? updateCartQuantities(Object.fromEntries(lines.map((line) => [line.key, 0])))
      : Promise.resolve(cart);
    const variantPromise = bags.length ? fetchPackVariants(handle) : Promise.resolve([]);

    const [nextCart, packVariants] = await Promise.all([removePromise, variantPromise]);

    if (!bags.length) return nextCart;

    if (!packVariants.length) {
      throw new Error('No pack variants available');
    }

    const desired = PackPricing.buildDesiredItems(bags, packVariants);
    await addCartItems(desired);
    return fetchCart();
  }

  function queueWrite(productId, handle, bags) {
    rebalanceLock = rebalanceLock
      .then(() => writeProductBags(productId, handle, bags))
      .catch((error) => {
        console.error(error);
        throw error;
      });
    return rebalanceLock;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function packLabel(count) {
    return count === 1 ? '1 pack' : `${count} packs`;
  }

  function grindOptionsHtml(selected, options) {
    const list = Array.isArray(options) && options.length ? options.slice() : ['Whole bean'];
    if (selected && !list.includes(selected)) list.unshift(selected);
    return list
      .map(
        (option) =>
          `<option value="${escapeHtml(option)}"${option === selected ? ' selected' : ''}>${escapeHtml(option)}</option>`,
      )
      .join('');
  }

  function itemImageHtml(item) {
    const src = item.image || item.featured_image;
    if (!src) return '<div class="cdp-cart-item-image-fallback"></div>';
    const url = typeof src === 'string' ? src : src;
    return `<img class="cdp-cart-item-image" src="${escapeHtml(url)}" alt="" loading="lazy" width="120" height="120">`;
  }

  async function buildProductViewModels(cart) {
    const config = getConfig();
    const byProduct = new Map();
    const order = await resolveStableCartOrder(cart);
    const orderIndex = new Map(order.map((key, index) => [key, index]));

    for (const item of cart.items || []) {
      const packs = PackPricing.packsFromCartItem(item);
      if (!packs) {
        if (!byProduct.has(`legacy-${item.key}`)) {
          byProduct.set(`legacy-${item.key}`, {
            kind: 'legacy',
            item,
          });
        }
        continue;
      }

      if (!byProduct.has(item.product_id)) {
        byProduct.set(item.product_id, {
          kind: 'pack',
          productId: item.product_id,
          handle: item.handle,
          title: item.product_title,
          url: item.url,
          image: item.image,
          bags: [],
        });
      }
      const group = byProduct.get(item.product_id);
      group.bags.push(...PackPricing.expandBagGrinds(item, packs));
      if (!group.image && item.image) group.image = item.image;
    }

    const entries = Array.from(byProduct.values()).sort((a, b) => {
      const indexA = orderIndex.has(viewEntryKey(a)) ? orderIndex.get(viewEntryKey(a)) : Number.MAX_SAFE_INTEGER;
      const indexB = orderIndex.has(viewEntryKey(b)) ? orderIndex.get(viewEntryKey(b)) : Number.MAX_SAFE_INTEGER;
      return indexA - indexB;
    });

    const views = [];
    for (const entry of entries) {
      if (entry.kind === 'legacy') {
        views.push(entry);
        continue;
      }

      const packVariants = await fetchPackVariants(entry.handle);
      const grindGroups = PackPricing.groupBagsByGrind(entry.bags);
      const clubbedPrice = PackPricing.bundledPriceCentsForBags(entry.bags, packVariants);
      const maxPacks = Number(config.maxPacks) || 20;

      grindGroups.forEach((grindGroup, index) => {
        views.push({
          kind: 'pack-grind',
          productId: entry.productId,
          handle: entry.handle,
          title: entry.title,
          url: entry.url,
          image: entry.image,
          grind: grindGroup.grind,
          count: grindGroup.count,
          showPrice: index === 0,
          clubbedPrice,
          totalPacks: entry.bags.length,
          maxPacks,
          bags: entry.bags,
        });
      });
    }

    return views;
  }

  function emptyStateHtml(config) {
    return `
      <div class="cdp-cart-empty" role="status" aria-live="polite">
        <h3 class="cdp-cart-empty-title">${escapeHtml(config.emptyTitle)}</h3>
        <p class="cdp-cart-empty-copy">${escapeHtml(config.emptyCopy)}</p>
        <a class="button button-link button-size-sm cdp-cart-empty-cta" href="${escapeHtml(config.emptyCtaUrl)}">
          <span class="button__label">${escapeHtml(config.emptyCtaLabel)}</span>
          <span class="button__arrow" aria-hidden="true">→</span>
        </a>
      </div>
    `;
  }

  function packGrindRowHtml(view, config) {
    const priceHtml = view.showPrice
      ? `<div class="cdp-cart-item-price" data-cart-item-price data-price-cents="${view.clubbedPrice}">${escapeHtml(
          PackPricing.formatMoney(view.clubbedPrice, config.moneyFormat),
        )}</div>`
      : `<div class="cdp-cart-item-price cdp-cart-item-price--muted" data-cart-item-price data-price-cents="0" aria-hidden="true"></div>`;

    return `
      <div
        class="cdp-cart-item"
        data-cart-pack-row
        data-cart-product-id="${view.productId}"
        data-cart-product-handle="${escapeHtml(view.handle)}"
        data-cart-grind="${escapeHtml(view.grind)}"
        data-cart-pack-count="${view.count}"
      >
        <div class="cdp-cart-item-media" aria-hidden="true">
          ${itemImageHtml(view)}
        </div>
        <div class="cdp-cart-item-main">
          <div class="cdp-cart-item-top">
            <div class="cdp-cart-item-name">${escapeHtml(view.title)}</div>
            ${priceHtml}
          </div>
          <div class="cdp-cart-item-meta">
            <div class="cdp-cart-size-field">
              <label class="cdp-cart-size-label">Grind:</label>
              <div class="cdp-cart-select-fit">
                <span class="cdp-cart-select-value" data-cart-grind-label aria-hidden="true">${escapeHtml(view.grind)}</span>
                <svg class="cdp-cart-select-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="m6 9 6 6 6-6"></path>
                </svg>
                <select class="cdp-cart-size-select" data-cart-grind-select aria-label="Grind for ${escapeHtml(view.title)}">
                  ${grindOptionsHtml(view.grind, config.grindOptions)}
                </select>
              </div>
            </div>
          </div>
          <div class="cdp-cart-item-controls">
            <div class="cdp-quantity" role="group" aria-label="Pack quantity">
              <button type="button" class="cdp-quantity-step" aria-label="Decrease packs" data-cart-quantity-decrease ${view.count <= 1 ? 'disabled' : ''}>
                <svg class="cdp-quantity-step-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14"></path></svg>
              </button>
              <div class="cdp-quantity-readout" aria-live="polite">
                <span class="cdp-quantity-primary" data-cart-pack-label>${escapeHtml(packLabel(view.count))}</span>
              </div>
              <button type="button" class="cdp-quantity-step" aria-label="Increase packs" data-cart-quantity-increase ${view.count >= view.maxPacks ? 'disabled' : ''}>
                <svg class="cdp-quantity-step-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 5v14"></path><path d="M5 12h14"></path></svg>
              </button>
            </div>
            <button type="button" class="button button-link-muted button-size-sm" data-cart-remove>
              <span class="button__label">Remove from cart</span>
            </button>
          </div>
        </div>
      </div>
    `;
  }

  function legacyRowHtml(item, config) {
    return `
      <div class="cdp-cart-item" data-cart-line-key="${escapeHtml(item.key)}" data-cart-quantity="${item.quantity}">
        <div class="cdp-cart-item-media" aria-hidden="true">${itemImageHtml(item)}</div>
        <div class="cdp-cart-item-main">
          <div class="cdp-cart-item-top">
            <div class="cdp-cart-item-name">${escapeHtml(item.product_title)}</div>
            <div class="cdp-cart-item-price" data-cart-item-price data-price-cents="${item.final_line_price}">${escapeHtml(
              PackPricing.formatMoney(item.final_line_price, config.moneyFormat),
            )}</div>
          </div>
          <div class="cdp-cart-item-controls">
            <button type="button" class="button button-link-muted button-size-sm" data-cart-remove-legacy>
              <span class="button__label">Remove from cart</span>
            </button>
          </div>
        </div>
      </div>
    `;
  }

  async function migrateLegacyBagGrindProperties(cart) {
    const productIds = [];
    const seen = new Set();

    (cart.items || []).forEach((item) => {
      const props = item.properties || {};
      if (!props['Bag grinds'] && !props.Bag_grinds) return;
      if (!PackPricing.packsFromCartItem(item)) return;
      if (seen.has(item.product_id)) return;
      seen.add(item.product_id);
      productIds.push(item.product_id);
    });

    if (!productIds.length) return cart;

    let nextCart = cart;
    for (const productId of productIds) {
      const lines = productLines(nextCart, productId);
      const handle = lines[0]?.handle;
      if (!handle) continue;
      nextCart = await queueWrite(productId, handle, expandProductBags(lines));
    }
    return nextCart;
  }

  async function renderCart(existingCart) {
    const drawer = getDrawer();
    if (!drawer) return null;

    drawerConfig = readDrawerConfig();
    const config = getConfig();
    let cart = existingCart || (await fetchCart());
    cart = await migrateLegacyBagGrindProperties(cart);
    const contents = drawer.querySelector('[data-cart-contents]') || drawer.querySelector('[data-cart-body]');
    const giftSlot = drawer.querySelector('[data-gift-slot]');
    const footer = drawer.querySelector('[data-cart-footer]');
    const subtotal = drawer.querySelector('[data-cart-subtotal]');

    setCartCounts(totalPackCount(cart));

    if (!contents) return cart;

    if (!cart.item_count) {
      contents.innerHTML = emptyStateHtml(config);
      if (giftSlot) giftSlot.hidden = true;
      if (footer) footer.hidden = true;
      if (subtotal) {
        subtotal.textContent = PackPricing.formatMoney(0, config.moneyFormat);
      }
      syncMagicCheckout(drawer, 0);
      return cart;
    }

    const views = await buildProductViewModels(cart);
    contents.innerHTML = `<div class="cdp-cart-items">${views
      .map((view) => (view.kind === 'legacy' ? legacyRowHtml(view.item, config) : packGrindRowHtml(view, config)))
      .join('')}</div>`;

    if (giftSlot) {
      const wasHidden = giftSlot.hidden;
      giftSlot.hidden = false;
      if (wasHidden && window.VanabrewGiftOptions?.applyCartAttributes) {
        window.VanabrewGiftOptions.applyCartAttributes(cart);
      }
    }
    if (footer) footer.hidden = false;
    if (subtotal) {
      subtotal.textContent = PackPricing.formatMoney(cart.total_price, config.moneyFormat);
    }
    syncMagicCheckout(drawer, cart.total_price);
    return cart;
  }

  function bagsForProductFromDom(productId) {
    const bags = [];
    document
      .querySelectorAll(`[data-cart-pack-row][data-cart-product-id="${productId}"]`)
      .forEach((row) => {
        const grind = row.getAttribute('data-cart-grind') || 'Whole bean';
        const count = Number(row.getAttribute('data-cart-pack-count')) || 0;
        for (let i = 0; i < count; i += 1) bags.push(grind);
      });
    return bags;
  }

  function updateOptimisticSubtotal() {
    const drawer = getDrawer();
    if (!drawer) return;

    let totalCents = 0;
    drawer.querySelectorAll('[data-cart-item-price]').forEach((node) => {
      totalCents += Number(node.getAttribute('data-price-cents')) || 0;
    });

    const subtotal = drawer.querySelector('[data-cart-subtotal]');
    if (subtotal) {
      subtotal.textContent = PackPricing.formatMoney(totalCents, getConfig().moneyFormat);
    }
    syncMagicCheckout(drawer, totalCents);
  }

  function updateOptimisticProductPrice(productId, handle) {
    const variants = productPackVariantCache.get(handle);
    if (!variants || !variants.length) return;

    const config = getConfig();
    const clubbedPrice = PackPricing.bundledPriceCentsForBags(bagsForProductFromDom(productId), variants);
    const rows = document.querySelectorAll(`[data-cart-pack-row][data-cart-product-id="${productId}"]`);

    rows.forEach((row, index) => {
      const priceEl = row.querySelector('[data-cart-item-price]');
      if (!priceEl) return;

      if (index === 0) {
        priceEl.classList.remove('cdp-cart-item-price--muted');
        priceEl.removeAttribute('aria-hidden');
        priceEl.textContent = PackPricing.formatMoney(clubbedPrice, config.moneyFormat);
        priceEl.setAttribute('data-price-cents', String(clubbedPrice));
      } else {
        priceEl.classList.add('cdp-cart-item-price--muted');
        priceEl.setAttribute('aria-hidden', 'true');
        priceEl.textContent = '';
        priceEl.setAttribute('data-price-cents', '0');
      }
    });

    updateOptimisticSubtotal();
  }

  async function updateGrindGroup(productId, handle, fromGrind, mutator) {
    await flushAllPendingQuantity({ render: false });
    const cart = await fetchCart();
    const bags = expandProductBags(productLines(cart, productId));
    const nextBags = mutator(bags.slice(), fromGrind);
    const nextCart = await queueWrite(productId, handle, nextBags);
    await renderCart(nextCart);
  }

  function bagsFromGrindCounts(grindCounts) {
    const bags = [];
    grindCounts.forEach((count, grind) => {
      const safeCount = Math.max(0, Number(count) || 0);
      for (let i = 0; i < safeCount; i += 1) bags.push(grind);
    });
    return bags;
  }

  function grindCountsEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [grind, count] of a) {
      if ((b.get(grind) || 0) !== count) return false;
    }
    return true;
  }

  function readProductGrindCounts(productId) {
    const grindCounts = new Map();
    document
      .querySelectorAll(`[data-cart-pack-row][data-cart-product-id="${productId}"]`)
      .forEach((row) => {
        const grind = row.getAttribute('data-cart-grind') || 'Whole bean';
        grindCounts.set(grind, Number(row.getAttribute('data-cart-pack-count')) || 0);
      });
    return grindCounts;
  }

  function ensurePendingQuantity(productId, handle) {
    let pending = pendingQuantityByProduct.get(productId);
    if (!pending) {
      pending = {
        handle,
        grindCounts: readProductGrindCounts(productId),
        timerId: null,
        flushing: false,
        flushPromise: null,
      };
      pendingQuantityByProduct.set(productId, pending);
    } else {
      pending.handle = handle;
    }
    return pending;
  }

  function updateOptimisticQuantityRow(row, nextCount, maxPacks) {
    row.setAttribute('data-cart-pack-count', String(nextCount));

    const label = row.querySelector('[data-cart-pack-label]');
    if (label) label.textContent = packLabel(nextCount);

    const decrease = row.querySelector('[data-cart-quantity-decrease]');
    const increase = row.querySelector('[data-cart-quantity-increase]');
    if (decrease) decrease.disabled = nextCount <= 1;
    if (increase) increase.disabled = nextCount >= maxPacks;
  }

  function scheduleQuantityFlush(productId) {
    const pending = pendingQuantityByProduct.get(productId);
    if (!pending) return;

    if (pending.timerId) window.clearTimeout(pending.timerId);
    pending.timerId = window.setTimeout(() => {
      flushPendingQuantity(productId).catch((error) => {
        console.error(error);
        renderCart().catch(() => {});
      });
    }, QUANTITY_DEBOUNCE_MS);
  }

  async function flushPendingQuantity(productId, options = {}) {
    const render = options.render !== false;
    const pending = pendingQuantityByProduct.get(productId);
    if (!pending) return;

    if (pending.timerId) {
      window.clearTimeout(pending.timerId);
      pending.timerId = null;
    }

    // Wait for an in-flight flush, then run again if new targets remain.
    if (pending.flushing && pending.flushPromise) {
      await pending.flushPromise;
      if (pendingQuantityByProduct.has(productId)) {
        await flushPendingQuantity(productId, { render });
      }
      return;
    }

    pending.flushing = true;
    pending.flushPromise = (async () => {
      const snapshot = new Map(pending.grindCounts);
      const handle = pending.handle;

      try {
        const nextCart = await queueWrite(productId, handle, bagsFromGrindCounts(snapshot));

        const latest = pendingQuantityByProduct.get(productId);
        if (latest && !grindCountsEqual(latest.grindCounts, snapshot)) {
          latest.flushing = false;
          latest.flushPromise = null;
          await flushPendingQuantity(productId, { render });
          return;
        }

        pendingQuantityByProduct.delete(productId);
        if (render && pendingQuantityByProduct.size === 0) {
          await renderCart(nextCart);
        }
      } catch (error) {
        pendingQuantityByProduct.delete(productId);
        if (render) await renderCart();
        throw error;
      }
    })();

    await pending.flushPromise;
  }

  async function flushAllPendingQuantity(options = {}) {
    const ids = Array.from(pendingQuantityByProduct.keys());
    for (const id of ids) {
      await flushPendingQuantity(id, { render: false });
    }
    if (options.render !== false && ids.length) {
      await renderCart();
    }
  }

  function applyOptimisticQuantityChange(row, delta) {
    const productId = Number(row.getAttribute('data-cart-product-id'));
    const handle = row.getAttribute('data-cart-product-handle');
    const grind = row.getAttribute('data-cart-grind') || 'Whole bean';
    const maxPacks = Number(getConfig().maxPacks) || 20;
    const current = Number(row.getAttribute('data-cart-pack-count')) || 1;
    const nextCount = Math.min(maxPacks, Math.max(1, current + delta));
    if (nextCount === current) return;

    const pending = ensurePendingQuantity(productId, handle);
    pending.grindCounts.set(grind, nextCount);
    updateOptimisticQuantityRow(row, nextCount, maxPacks);
    setCartCounts(totalPackCountFromDom());

    if (productPackVariantCache.has(handle)) {
      updateOptimisticProductPrice(productId, handle);
    } else {
      fetchPackVariants(handle)
        .then(() => updateOptimisticProductPrice(productId, handle))
        .catch(() => {});
    }

    scheduleQuantityFlush(productId);
  }

  async function handleAddToCart(form) {
    const grindField = form.querySelector('[data-product-grind], [name="properties[Grind]"]');
    const grind = String(grindField?.value || '').trim();
    // Product forms require an explicit grind; do not default to Whole bean.
    if (grindField && !grind) return;

    const submitter = form.querySelector('[type="submit"]');
    if (submitter) submitter.disabled = true;

    try {
      await flushAllPendingQuantity({ render: false });

      const productId = Number(form.getAttribute('data-product-id'));
      const handle = form.getAttribute('data-product-handle');
      const packCount = Math.max(1, Number(form.dataset.packCount) || Number(form.querySelector('[name="quantity"]')?.value) || 1);

      if (!productId || !handle) {
        // Fallback to native add for non-configured forms.
        const quantityInput = form.querySelector('[name="quantity"]');
        if (quantityInput) quantityInput.value = '1';
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        if (!response.ok) throw new Error('Add to cart failed');
      } else {
        const cart = await fetchCart();
        const existing = expandProductBags(productLines(cart, productId));
        const added = Array.from({ length: packCount }, () => grind);
        await queueWrite(productId, handle, existing.concat(added));
      }

      await renderCart();
      openDrawer();
    } catch (error) {
      console.error(error);
      openDrawer();
    } finally {
      if (submitter) {
        const stillNeedsGrind = Boolean(grindField) && !String(grindField.value || '').trim();
        submitter.disabled = false;
        if (stillNeedsGrind) submitter.setAttribute('aria-disabled', 'true');
        else submitter.removeAttribute('aria-disabled');
      }
    }
  }

  async function handleCartInteraction(event) {
    const row = event.target.closest('[data-cart-pack-row]');
    if (row) {
      if (event.target.closest('[data-cart-quantity-decrease]')) {
        event.preventDefault();
        applyOptimisticQuantityChange(row, -1);
        return;
      }

      if (event.target.closest('[data-cart-quantity-increase]')) {
        event.preventDefault();
        applyOptimisticQuantityChange(row, 1);
        return;
      }

      const productId = Number(row.getAttribute('data-cart-product-id'));
      const handle = row.getAttribute('data-cart-product-handle');
      const grind = row.getAttribute('data-cart-grind') || 'Whole bean';

      if (event.target.closest('[data-cart-remove]')) {
        event.preventDefault();
        await updateGrindGroup(productId, handle, grind, (bags) => bags.filter((bag) => bag !== grind));
        return;
      }
    }

    const legacy = event.target.closest('[data-cart-line-key]');
    if (legacy && event.target.closest('[data-cart-remove-legacy]')) {
      event.preventDefault();
      await flushAllPendingQuantity({ render: false });
      await changeCartLine(legacy.getAttribute('data-cart-line-key'), { quantity: 0 });
      await renderCart();
    }
  }

  async function handleGrindChange(event) {
    const select = event.target.closest('[data-cart-grind-select]');
    if (!select) return;

    const row = select.closest('[data-cart-pack-row]');
    if (!row) return;

    const productId = Number(row.getAttribute('data-cart-product-id'));
    const handle = row.getAttribute('data-cart-product-handle');
    const fromGrind = row.getAttribute('data-cart-grind') || 'Whole bean';
    const toGrind = select.value;
    if (!toGrind || toGrind === fromGrind) return;

    const label = row.querySelector('[data-cart-grind-label]');
    if (label) label.textContent = toGrind;

    try {
      await updateGrindGroup(productId, handle, fromGrind, (bags) =>
        bags.map((bag) => (bag === fromGrind ? toGrind : bag)),
      );
    } catch (error) {
      await renderCart();
    }
  }

  document.addEventListener('click', (event) => {
    const cartToggle = event.target.closest('[data-cart-toggle]');
    if (cartToggle) {
      event.preventDefault();
      renderCart()
        .then(() => openDrawer())
        .catch(() => openDrawer());
      return;
    }

    const closeButton = event.target.closest('[data-cart-drawer-close]');
    if (closeButton) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    if (
      event.target.closest(
        '[data-cart-quantity-decrease], [data-cart-quantity-increase], [data-cart-remove], [data-cart-remove-legacy]',
      )
    ) {
      handleCartInteraction(event).catch((error) => {
        console.error(error);
        renderCart().catch(() => {});
      });
    }
  });

  document.addEventListener('change', (event) => {
    if (!event.target.closest('[data-cart-grind-select]')) return;
    handleGrindChange(event).catch((error) => {
      console.error(error);
      renderCart().catch(() => {});
    });
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest(addFormSelector);
    if (form && getDrawer()) {
      event.preventDefault();
      handleAddToCart(form);
      return;
    }
  });

  document.addEventListener('keydown', (event) => {
    const drawer = getDrawer();
    if (!drawer || drawer.hidden || !drawer.classList.contains('is-open')) return;
    if (event.key === 'Escape') closeDrawer();
  });

  // First paint for non-empty carts that were SSR'd as an empty items shell.
  // Also open the drawer when /cart redirected here (session flag).
  if (getDrawer()) {
    let shouldOpenFromRedirect = false;
    try {
      shouldOpenFromRedirect = sessionStorage.getItem('vb_open_cart') === '1';
      if (shouldOpenFromRedirect) sessionStorage.removeItem('vb_open_cart');
    } catch (e) {}

    if (getConfig().initialItemCount > 0 || shouldOpenFromRedirect) {
      renderCart()
        .then(() => {
          if (shouldOpenFromRedirect) openDrawer();
        })
        .catch(() => {
          if (shouldOpenFromRedirect) openDrawer();
        });
    }
  }

  watchMagicCheckout();
})();
